function state() {
  return {
    tabData: {
      all: {
        pagination: {
          itemsPerPage: 10,
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: null,
        showBy: null,
        dateRange: null,
        type: null,
      },
      inforce: {
        pagination: {
          itemsPerPage: 10,
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: null,
        showBy: null,
        dateRange: null,
        type: null,
      },
      pending: {
        pagination: {
          itemsPerPage: 10,
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: null,
        showBy: null,
        dateRange: null,
        type: null,
      },
      reject: {
        pagination: {
          itemsPerPage: 10,
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: null,
        showBy: null,
        dateRange: null,
        type: null,
      },
      maturity: {
        pagination: {
          itemsPerPage: 10,
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: null,
        showBy: null,
        dateRange: null,
        type: null,
      },
    },
  };
}

export default state;
